import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { CardCell } from './CardCell.js';
export const getScheduleDescription = (workScheduleWeek) => {
    const rows = getDateDescription(workScheduleWeek);
    return _jsx(CardCell, { label: "\u0420\u0435\u0436\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u044B", value: rows, className: "max-w-none" });
};
export const buildScheduleText = ({ workTime = '', lunchHour = '', daysOff = '' }, isSaturday = false) => {
    if (!workTime) {
        return '';
    }
    return [
        `${isSaturday ? 'Суббота' : 'Будние дни'}: ${workTime}`,
        lunchHour ? `перерыв: ${lunchHour}` : '',
        daysOff ? `не работает: ${daysOff}` : '',
    ]
        .filter(Boolean)
        .join('; ');
};
export const getDateDescription = (workScheduleWeek) => {
    const workingWeekday = workScheduleWeek.find((_) => _.key !== 'workingSaturday' && Boolean(_.status) && Boolean(_.workTime));
    const workingSaturday = workScheduleWeek.find((_) => _.key === 'workingSaturday' && Boolean(_.status) && Boolean(_.workTime));
    const daysOff = workScheduleWeek
        .filter((_) => !_.status)
        .map((_) => _.short?.toLowerCase())
        .join(', ');
    const rows = [
        buildScheduleText({
            workTime: workingWeekday?.workTime,
            lunchHour: workingWeekday?.lunchHour,
            daysOff: workingSaturday ? '' : daysOff,
        }),
        buildScheduleText({ workTime: workingSaturday?.workTime, lunchHour: workingSaturday?.lunchHour, daysOff }, true),
    ].filter(Boolean);
    return rows;
};
//# sourceMappingURL=getScheduleDescription.js.map